<template>
    <div class="page px-4">
        <div v-if="isLoaded && fromLbl">
            <div>
                <img class="rounded-lg" :src="missionFGF" alt=""/>
            </div>
            <div class="bg-white rounded-xl px-6 py-4 mt-5">
                <div class="text-center font-bold text-20 text-blue-1 pb-6">กิจกรรมเพื่อนแนะนำเพื่อน<br>กรุณาแชร์โค้ดนี้ให้เพื่อนของคุณ</div>
                <div class="border-t pt-4">
                    <button class="w-full rounded-full py-2.5 bg-green-1 text-white text-22" @click="clickShare()">แชร์โค้ด</button>
                </div>
            </div>
            <div v-show="isProfile && !isUsedRefCode">
                <div class="bg-white rounded-xl px-6 py-4 mt-5">
                    <div class="text-center font-bold text-20 text-blue-1 pb-5">กรุณาระบุโค้ดของเพื่อนที่แนะนำ</div>
                    <InputText
                        class="refcode-input"
                        ref="clear-input"
                        v-model:inputValue="lblInputCode"
                        :inputLbl="fromLbl"
                        :maxLength="15"
                        :errorInfo="formErrorInfo[0]"
                        :isUpperCase="true">
                    </InputText>
                    <div class="border-t pt-4">
                        <button class="w-full rounded-full py-2.5 bg-green-1 text-white text-22" @click="clickConfirm()">ยืนยัน</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalMaster :controller="modalController"></ModalMaster>
</template>

<script>
import ConfigManager from '@/config/ConfigManager';
import ModalMixin from "@/mixin/ModalMixin.js";
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
import { FormHelper } from '@/helper/FormHelper.js';
import FriendGetFriend from '../service/FriendGetFriend';
import InputText from '@/components/Input/label/InputText.vue';
export default {
    name: 'FriendGetFriend',
    mixins: [ModalMixin,AuthStatusMixin,LocaleMixin],
    components: {
        InputText,
    },
    data: function() {
        return {
            formErrorInfo: [],
            lblInputCode: '',
            fromLbl: null,
            missionFGF: '',
            codeShare: '',
            isUsedRefCode: false,
            isLoaded: false,
            isProfile: false,
        }
    },
    created: function() {
        this.initialFGFModal();
        this.initFGF();
    },
    methods: {
        initFGF: async function() {
            this.formErrorInfo = FormHelper.genErrorInfo(1);
            this.missionFGF = this.getMissionFGF();
            this.fromLbl = this.lbl.FGF.fromLbl;
            this.isProfile = await this.getProfile();
            this.isLoaded = true;
        },
        getMissionFGF: function() {
            return ConfigManager.getBlobUrl() + "/config/splus/images/fgf.jpg";
        },
        getProfile: function() {
            return new Promise((resolve) => {
                FriendGetFriend.getFriendCode().subscribe({
                    next: (data) => {
                        this.codeShare = data.friend_get_friend_code;
                        this.isUsedRefCode = data.is_get_friend_code || false ;
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        clickShare: async function() {
            if (!this.isLogin) return this.checkLoginPopup();
            this.fgfModal
                .setTitle('กรุณากรอกโค้ดเพื่อรับคะแนน')
                .setMsg(this.codeShare)
                .setBtnOk('แชร์โค้ด')
                .show();
            this.fgfModal.onClickOk(() => {
                this.shareLine();
            });
            // this.sharefgfModal.onClickShare((shareType)=> {
            //     if (shareType == "facebook") {
            //         this.shareFacebook();
            //     } else if (shareType == "line") {
            //         this.shareLine();
            //     } else if (shareType == "twitter") {
            //         this.shareTwitter();
            //     }
            // });
        },
        clickConfirm: function() {
            if (this.lblInputCode == '' || this.lblInputCode == null) {
                this.alertModal
                    .setMsg('กรุณาระบุโค้ดของเพื่อนที่แนะนำ')
                    .show()
                return ;
            }
            let params = {};
                params.code = this.lblInputCode || '';
                params.device_app_id = ConfigManager.getAppId();

            return new Promise((resolve) => {
                FriendGetFriend.postFriendCode(params).subscribe({
                    next: (data) => {
                        console.log(data)
                        this.$refs['clear-input'].clearText();
                        this.alertModal
                            .setMsg('ใช้สำเร็จ')
                            .show()
                        this.alertModal.onClickClose(()=> {
                            this.isUsedRefCode = true;
                        });
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        if(err.id == 404 && err.code == 404) {
                            this.alertModal
                            .setMsg('กรุณาระบุโค้ดที่ถูกต้อง')
                            .show()
                        } else {
                            this.alertModal
                            .setMsg(err.message)
                            .show()
                        }
                        resolve(false);
                    }
                });
            });
        },
        getUrlShare: function() {
            let url = "";
                url = window.location.origin + "/getcode";

                url += "?ref=" + this.codeShare;
                return url;
        },
        shareFacebook: function() {
            try {
                let share_url = this.getUrlShare();
                let redirect_uri = window.location.href;

                if (window.location.href.indexOf("?") == -1) {
                    redirect_uri += "?success=true";
                }
                else {
                    redirect_uri += "&success=true";
                }

                let param = {
                    link: encodeURIComponent(share_url),
                    redirect_uri: encodeURIComponent(redirect_uri)
                };

                let urlShare = "https://www.facebook.com/dialog/feed?app_id=" + ConfigManager.getAppId() + "&display=popup&link=" + param.link + "&redirect_uri=" + param.redirect_uri;
                window.location = urlShare;
            }
            catch (e) {
                console.log(e.message);
            }
        },
        shareLine: function () {
            let url = this.getUrlShare();
            let text = "เพื่อนแนะนำเพื่อน";
            let shareURL = "https://lineit.line.me/share/ui?url=" + encodeURIComponent(url) + "&text=" + encodeURIComponent(text);
            window.open(shareURL, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        },
        shareTwitter: function () {
            // Opens a pop-up with twitter sharing dialog
            let shareURL = "http://twitter.com/share?"; //url base
            let params = {
                url: this.getUrlShare(),
                text: "",
            }
            for (let prop in params) shareURL += '&' + prop + '=' + encodeURIComponent(params[prop]);
            window.open(shareURL, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        }
    }
}
</script>

<style lang="scss">
    .refcode-input {
        input {
            text-align: center;
        }
        ::placeholder {
            text-align: center;
        }
    }
</style>
